import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useQuery } from '@apollo/react-hooks';
import { GoalOptionsQuery, GoalOptionsQueryVariables } from './__generated__/GoalOptionsQuery';

const GOAL_OPTIONS_QUERY = gql`
  query GoalOptionsQuery($campaignId: ID) {
    goalOptions(campaignId: $campaignId)
  }
`;

export const useGoalOptionsQuery = (variables: GoalOptionsQueryVariables) => {
  return useQuery<GoalOptionsQuery, GoalOptionsQueryVariables>(GOAL_OPTIONS_QUERY, {
    client: kmsClient,
    variables
  });
};
